/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const getTimesheetProjectsQueryParamsSchema = z
  .object({
    search: z.string().optional(),
    customerSearch: z.string().optional(),
    size: z.coerce.number().int().optional(),
    mockUser: z.coerce.number().int().optional(),
  })
  .optional();

/**
 * @description OK
 */
export const getTimesheetProjects200Schema = z.array(
  z.object({
    customerId: z.coerce.number().int(),
    customerName: z.coerce.string(),
    projectId: z.coerce.number().int().nullable().nullish(),
    projectName: z.coerce.string(),
  }),
);

export const getTimesheetProjectsQueryResponseSchema = z.lazy(
  () => getTimesheetProjects200Schema,
);
